import { render, staticRenderFns } from "./KEmptyPlaceholder.vue?vue&type=template&id=141d9e83&scoped=true"
import script from "./KEmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./KEmptyPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d9e83",
  null
  
)

export default component.exports